import { createContext } from 'react';

import { emptyFn } from '@app/constants';
import type { NClientPaymentsProvider } from '@app/providers/ClientPaymentsProvider/ClientPaymentsProvider.types';

export const ClientPaymentsContext =
  createContext<NClientPaymentsProvider.Context>({
    isPaymentsModalOpen: false,
    setIsPaymentsModalOpen: () => {},
    isCollectionsModalOpen: false,
    setIsCollectionsModalOpen: () => {},
    isExpensesModalOpen: false,
    setIsExpensesModalOpen: () => {},
    searchId: null,
    setSearchId: emptyFn,
  });
